import React, { useState, useEffect } from 'react';
import { useStyles, Autocomplete2 } from '@webapps/styles';
import { useMutation } from '@webapps/reactjs-tech-components';
import { getAddress } from '@webapps/business';
// import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// import L from 'leaflet';

// // leaflet bug
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });

function MapUpdater({ center }) {
    const map = useMap();
    useEffect(() => {
        if (center) {
            map.setView(center, 13);
        }
    }, [center, map]);
    return null;
}

export default function Step2() {
  const { classes } = useStyles(styles);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [mapCenter, setMapCenter] = useState([48.8566, 2.3522]); // Default to Paris

  const getAddressInfo = useMutation(getAddress, {
    onSuccess: (result) => {
      setAddresses(result?.data?.features || []);
    },
  });

  const handleChangeAddress = async (e) => {
    const value = e.target.value;
    if (!value || value.length < 3) {
      setAddresses([]);
      return;
    }
    await getAddressInfo.mutateAsync({ name: value });
  };

  const handleSelectAddress = (option) => {
    setSelectedAddress(option);
    if (option) {
        // Properties are [longitude, latitude]
        const [lon, lat] = option.value.geometry.coordinates;
        setMapCenter([lat, lon]);
    }
  };

  return (
    <>
      <div className={classes.framerDiv11}>
        <div className={classes.framerP4}>Où habites-tu ?</div>
        <div className={classes.framerP5}>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry.
        </div>
      </div>
      <div className={classes.framerDiv8}>
        <div className={classes.framerP3}>Adresse postale - Ville</div>
        <Autocomplete2
          options={addresses.map((addr) => ({
            label: addr.properties.label,
            value: addr,
          }))}
          placeholder=""
          onChange={handleSelectAddress}
          onInputChange={handleChangeAddress}
          value={selectedAddress}
        />
      </div>
      <MapContainer center={mapCenter} zoom={13} style={{ height: '400px', width: '100%', marginTop: '20px' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {selectedAddress && (
            <Marker position={mapCenter}>
                <Popup>
                    {selectedAddress.label}
                </Popup>
            </Marker>
        )}
        <MapUpdater center={mapCenter} />
      </MapContainer>
    </>
  );
}

const styles = () => ({
  framerDiv11: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '100%',
    gap: '10px',
  },
  framerP4: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: '24px',
    fontWeight: '600',
    textAlign: 'left',
    color: '#152652',
    width: '100%',
    lineHeight: 'normal',
  },
  framerP5: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '15px',
    textAlign: 'left',
    color: '#5d75a8',
  },
  framerDiv8: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: '8px',
  },
  framerP3: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '14px',
    fontWeight: '400',
    color: '#92ABD2',
  },
}); 